// extracted by mini-css-extract-plugin
export default {"overlay":"vz-z","bodyOpen":"wz-z","content":"xz-z","header":"yz-z","close":"zz-z","closeNoHeading":"Az-z"};